import { Component, ViewChild, AfterViewInit, ElementRef} from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { CargadorPcPage } from '../cargador-pc/cargador-pc';
import { DesafioPersonalProvider } from '@providers/desafio-personal/desafio-personal';
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { UserInfoComponent } from '../../../components/user-info/user-info';
import { CampaignActiveComponent } from '../../../components/campaign-active/campaign-active';
import { ASSETS } from '@env';
import { BuscarTcPage, DetalleRondaPage, HistoricoRetosPage, BusquedaTesoroInstruccionesPage, InfoBotsPage } from '@pages';
import { DashboardProvider } from '@providers/dashboard/dashboard';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ModalSinOponenteComponent } from '../../../components/modal-sin-oponente/modal-sin-oponente';
import { ModalRetosPausadosComponent } from '../../../components/modal-retos-pausados/modal-retos-pausados';
import { LoadingProvider } from '@providers/loading/loading';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { TranslateService } from '@ngx-translate/core';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';

@Component({
  selector: 'page-home-pc',
  templateUrl: 'home-pc.html',
})
export class HomePCPage implements AfterViewInit {

  @ViewChild(ModalSinOponenteComponent) modalSinOponente: ModalSinOponenteComponent;
  @ViewChild(ModalRetosPausadosComponent) modalRetosPausados: ModalRetosPausadosComponent;

  sugerencias: Array<any> = [];
  sugerenciasRequest: Boolean = true;

  primerDesafio: Array<any> = [];
  primerDesafiosRequest: Boolean = true;

  miTurno: Array<any> = [];
  miTurnoRequest: Boolean = true;

  suTurno: Array<any> = [];
  suTurnoRequest: Boolean = true;

  historico: any = {
    existeHistorico: false
  };
  historicoRequest: Boolean = true;

  jugador: Jugador;
  equipo: Equipo;
  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;

  campania: any;

  busquedaTesoro: any;

  public retosCaducos: Observable<any>;
  private $retosCaducos: Subject<any>;

  @ViewChild(UserInfoComponent) header: UserInfoComponent
  @ViewChild(CampaignActiveComponent) campaignComponent: CampaignActiveComponent
  @ViewChild('main', { read: ElementRef }) main: ElementRef;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    private authProvider: AuthProvider,
    private dashboardProvider: DashboardProvider,
    private desafioPersonalProvider: DesafioPersonalProvider,
    private loadingProvider: LoadingProvider,
    private campaignsProvider: CampaignsProvider,
    private translate: TranslateService,
    private busquedaTesoroProvider: BusquedaTesoroProvider
  ) {
    this.$retosCaducos = new Subject<any>();
    this.retosCaducos = this.$retosCaducos.asObservable();
  }

  ionViewWillEnter() {
    this.authProvider.getSession()
    .then( jugador => {
      this.jugador = jugador;
      return this.authProvider.getEquipo();
    })
    .then( equipo => {
      this.equipo = equipo;
      return this.desafioPersonalProvider.getRondaActual();
    })
    .then( ronda => {
      if(ronda && ronda.juego && Object.keys(ronda.juego).length) {
        this.app.getRootNavs()[0].setRoot(CargadorPcPage, ronda);
      } else {
        this.initRequest();
      }
    })
    .catch( e => console.log(e));
  }

  private async _sugerencias(){
    this.sugerenciasRequest = true;
    try {
      this.sugerencias = await this.desafioPersonalProvider.sugerencias(this.equipo.area._id, this.jugador._id);
    } catch( e ) {
      console.log('_sugerencias', e);
    } finally {
      this.sugerenciasRequest = false;
    }
  }

  private async _existeHistoricoRetos(){
    this.historicoRequest = true;
    try {
      this.historico = await this.dashboardProvider.existeHistoricoRetos(this.equipo.area._id, this.jugador._id);
    } catch( e ) {
      console.log('_existeHistoricoRetos', e);
    } finally {
      this.historicoRequest = false;
    }
  }

  private async _updateScore(){
    try {
      await this.header.updateScore();
    } catch( e ) {
      console.log('_updateScore', e);
    }
  }

  private async _caducados(){
    try {
      let caducos = await this.desafioPersonalProvider.caducados(this.equipo.area._id, this.jugador._id);
      this.$retosCaducos.next(caducos);
      if(caducos.length > 0) {
        await this.desafioPersonalProvider.actualizaCaducados(this.equipo.area._id, this.jugador._id);
      }
    } catch( e ) {
      console.log('_caducados', e);
    }
  }

  private async _primerDesafio(){
    this.primerDesafiosRequest = true;
    try {
      this.primerDesafio = await this.desafioPersonalProvider.primerDesafio(this.equipo.area._id, this.jugador._id);
    } catch( e ) {
      console.log('_primerDesafio', e);
    } finally {
      this.primerDesafiosRequest = false;
    }
  }

  private async _suTurno(){
    this.suTurnoRequest = true;
    try {
      this.suTurno = await this.desafioPersonalProvider.enCursoSuTurno(this.equipo.area._id, this.jugador._id);
    } catch( e ) {
      console.log('_suTurno', e);
    } finally {
      this.suTurnoRequest = false;
    }
  }

  private async _miTurno(){
    this.miTurnoRequest = true;
    try {
      this.miTurno = await this.desafioPersonalProvider.enCursoMiTurno(this.equipo.area._id, this.jugador._id);
    } catch( e ) {
      console.log('_miTurno', e);
    } finally {
      this.miTurnoRequest = false;
    }
  }

  private async _verificaCampania() {
    await this.campaignComponent.init();
    await this.header.ngAfterViewInit();
    await this.ngAfterViewInit();
  }

  async initRequest(refresher = null) {
    this._sugerencias();
    this._existeHistoricoRetos();
    this._updateScore();
    this._verificaCampania();

    this._primerDesafio();
    this._miTurno();
    this._suTurno();

    this._caducados();

    this.buscaCertamenActivo();

    if ( refresher ) {
      refresher.complete();
    }

  }

  async ngAfterViewInit() {
    try {
      let campaign = await this.campaignsProvider.get();
      if(campaign) {
        this.campania = campaign;
        // this.main.nativeElement.style.backgroundImage = "url('assets/imgs/subheader-campaign.svg')";
      } else {
        // this.main.nativeElement.style.backgroundImage = "url('assets/imgs/pchome__bg.svg')";
      }
    } catch (error) {
      // this.main.nativeElement.style.backgroundImage = "url('assets/imgs/pchome__bg.svg')"
    }


      // this.campaignsProvider.get()
      // .then( campaign => {
      //   if(campaign) {
      //     this.campania = campaign;
      //     this.main.nativeElement.style.backgroundImage = "url('assets/imgs/subheader-campaign.svg')";
      //   } else {
      //     this.main.nativeElement.style.backgroundImage = "url('assets/imgs/pchome__bg.svg')";
      //   }
      // })
      // .catch( e => this.main.nativeElement.style.backgroundImage = "url('assets/imgs/pchome__bg.svg')" );
  }

  ionViewDidLoad() {
  }

  async buscaCertamenActivo() {
    try {
      this.busquedaTesoro =  await this.busquedaTesoroProvider.buscaCertamenActivo(this.equipo.area._id);
      if(this.busquedaTesoro ) {
        let muestraInstrucciones = await this.busquedaTesoroProvider.muestraInstrucciones();

        if(!muestraInstrucciones) {
          this.app.getRootNavs()[0].setRoot(BusquedaTesoroInstruccionesPage, {
            busquedaTesoro: this.busquedaTesoro
          });

          await this.busquedaTesoroProvider.actualizaMuestraInstrucciones(true);
        }
      } else {
        await this.busquedaTesoroProvider.actualizaMuestraInstrucciones(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async puedeRetar() {
    const _puedeJugar = await this.desafioPersonalProvider.puedeRetar(this.equipo.area._id);
    return _puedeJugar.jugar;
  }

  async retoAleatorio() {
    this.loadingProvider.show(true);

    const _puedeJugar = await this.puedeRetar();
    if(!_puedeJugar) {
      this.modalRetosPausados.show = true;
      this.loadingProvider.show(false);
      return;
    }

    if(this.sugerencias.length == 0 && !this.campania) {
      this.loadingProvider.show(false);
      return this.retoBot('YIBI-1');  
    }
    
    this.authProvider.getSession()
      .then( jugador => {
        this.jugador = jugador;
        return this.authProvider.getEquipo();
      })
      .then( equipo => {
        this.equipo = equipo;
        return this.desafioPersonalProvider.aleatorio(this.equipo.area._id, this.jugador._id);
      })
      .then( juego => {
        this.app.getRootNavs()[0].setRoot(CargadorPcPage, {
          jugador: this.jugador,
          equipo: this.equipo,
          juego:  juego
        });
      })
      .then( _ => this.loadingProvider.show(false) )
      .catch( e => {
        this.modalSinOponente.show = true;
        this.loadingProvider.show(false);
      });
  }

  async retoDirecto(retador: string) {
    this.loadingProvider.show(true);

    const _puedeJugar = await this.puedeRetar();
    if(!_puedeJugar) {
      this.modalRetosPausados.show = true;
      this.loadingProvider.show(false);
      return;
    }

    
    this.authProvider.getSession()
    .then( jugador => {
      this.jugador = jugador;
      return this.authProvider.getEquipo();
    })
    .then( equipo => {
      this.equipo = equipo;
      return this.desafioPersonalProvider.directo(this.equipo.area._id, this.jugador._id, retador);
    })
    .then( juego => {
      const rondaPersonal = {
        jugador: this.jugador,
        equipo: this.equipo,
        juego:  juego
      };
      this.app.getRootNavs()[0].setRoot(CargadorPcPage, rondaPersonal);
    })
    .then( _ => this.loadingProvider.show(false) )
    .catch( e => {
      console.log(e);
      this.loadingProvider.show(false);
    });
  }

  tomarTurno(desafio: any, oponente: string) {
    this.loadingProvider.show(true);
    this.desafioPersonalProvider.caducados(this.equipo.area._id, this.jugador._id)
      .then( async caducos => {
        if(caducos.length >= 1 ) {
          this.primerDesafio = this.primerDesafio.filter( r => r.desafio != desafio.desafio);
          this.miTurno = this.miTurno.filter( r => r.desafio != desafio.desafio);
          this.$retosCaducos.next(caducos);
          return Promise.reject('Reto no valido: '+ desafio);
        }

        return this.desafioPersonalProvider.miTurno(desafio.desafio, oponente);
      })
      .then( juego => {
        juego.totalRondas = desafio.totalRondas;
        juego.rondaActual = desafio.rondaActual;
        this.app.getRootNavs()[0].setRoot(CargadorPcPage, {
          jugador: this.jugador,
          equipo: this.equipo,
          juego:  juego
        });
      })
      .then( _ => this.loadingProvider.show(false) )
      .catch( e => {
        console.log(e)
        this.loadingProvider.show(true);
      });
  }

  buscaOponente() {
    this.navCtrl.push(BuscarTcPage);
  }

  detalleRonda(reto) {
    this.navCtrl.push(DetalleRondaPage, {
      areaID: this.equipo.area._id,
      jugadorID: this.jugador._id,
      oponenteID: reto.oponente._id,
    });
  }

  historialRetos() {
    this.navCtrl.push(HistoricoRetosPage);
  }

  translateUnit(unidad) {
    switch(unidad) {
        case 'días':
          return this.translate.instant('personalChallenge.homePc.days');
        case 'horas':
          return this.translate.instant('personalChallenge.homePc.hours');
        case 'minutos':
          return this.translate.instant('personalChallenge.homePc.minutes');
        default:
        return unidad;
    }
  }

  async retoBot(tipoBot: string) {
    this.loadingProvider.show(true);

    let reto = await this.desafioPersonalProvider.retoBot(this.equipo.area._id);
    reto.tipoBot = tipoBot;
    

    let modalBot = await this.desafioPersonalProvider.muestraModalBots();
    if(modalBot) {
      await this.app.getRootNavs()[0].setRoot(CargadorPcPage, {
        jugador: this.jugador,
        equipo: this.equipo,
        bot: reto
      });  

      this.loadingProvider.show(false);
    } else {
      await this.app.getRootNavs()[0].setRoot(InfoBotsPage, {
        jugador: this.jugador,
        equipo: this.equipo,
        bot: reto,
      });

      this.loadingProvider.show(false);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/home-pc/home-pc.ts